export default __webpack_public_path__ + "static/media/headshot-russ.13d36b95.png";